import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Confirm, Icon, Image, Label, List, Segment } from 'semantic-ui-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../../app/stores/store';
import { useTranslation } from 'react-i18next';
import { TeamDto } from '../../app/models/Team';
import UserScoreButton from '../userRatings/UserScoreButton';

interface Props { team: TeamDto; }

export default observer(function TeamRosterPanel({ team }: Props) {
  const { teamStore } = useStore();
  const { t } = useTranslation();
  const [confirmRemove, setConfirmRemove] = useState<string | null>(null);

  return (
    <Segment>
      <List divided relaxed>
        {team.teamMembers.map(member => (
          <List.Item key={member.userId}>
            <Image avatar src={member.imageUrl || '/assets/user.png'} />
            <List.Content>
              <List.Header>
                <Link to={`/profiles/${member.userId}`}>
                  {member.fullName}
                </Link>
                <Label size="tiny" color={member.role === 'Captain' ? 'blue' : 'grey'} style={{ marginLeft: 8 }}>
                  <Icon name={member.role === 'Captain' ? 'star' : 'user'} />
                  {t(`teams.roles.${member.role.toLowerCase()}`)}
                </Label>
              </List.Header>
              <List.Description>
                {t('teams.joinedAt')}: {new Date(member.joinedAt).toLocaleDateString()}
              </List.Description>
            </List.Content>

            <List.Content floated="right" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              
              {team.isCurrentUserCaptain && member.userId !== team.createdByUserID && (
                <>
                  {member.role === 'Player' && (
                    <Button size="mini" basic color="blue"
                      onClick={() => teamStore.promoteMember(team.id, member.userId)}
                      loading={teamStore.submitting}>
                      <Icon name="star" />{t('teams.promote')}
                    </Button>
                  )}
                  <Button size="mini" basic color="red"
                    onClick={() => setConfirmRemove(member.userId)}>
                    <Icon name="trash" />{t('teams.remove')}
                  </Button>
                </>
              )}
              <UserScoreButton
                userId={member.userId}
                sportId={team.sportID}
                buttonText={t('gameDetailedSidebar.viewStats') || 'Stats'}
                size='medium'
              />
            </List.Content>
          </List.Item>
        ))}
      </List>

      <Confirm
        open={!!confirmRemove}
        content={t('teams.confirmRemoveMember')}
        cancelButton={t('teams.cancel')}
        confirmButton={<Button negative content={t('teams.remove')} />}
        onCancel={() => setConfirmRemove(null)}
        onConfirm={async () => {
          if (confirmRemove) await teamStore.removeMember(team.id, confirmRemove);
          setConfirmRemove(null);
        }}
      />
    </Segment>
  );
});